import React from "react";
import tw from "twin.macro";
import styled from "styled-components";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";


const Container = styled.div`
${tw`relative -mx-8 -mt-8 bg-cover`}
background-image: url("bc.png");
`;
const Container2023 = styled.div`
${tw`relative -mx-8 -mt-8 bg-cover`}
background-image: url("bc2023.png");
`;

const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
  props.buttonRounded && tw`rounded-full`
]);



const HeroContainer = tw.div`z-20 relative px-4 sm:px-8 max-w-screen-xl mx-auto`;
const TwoColumn = tw.div`pt-24 pb-32 px-4 flex justify-between items-center flex-col lg:flex-row`;
const LeftColumn = tw.div`flex flex-col items-center lg:block`;

const SubHeading2 = styled.h3`
  ${tw`text-center sm:text-xl lg:text-2xl xl:text-3xl font-black text-black leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Content = tw.div`px-4 flex flex-1 flex-col justify-center items-center`;

const Heading = styled.h1`
  ${tw`text-3xl text-center sm:text-4xl lg:text-5xl xl:text-6xl font-black text-black leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const SubHeading = styled.h2`
  ${tw`text-2xl sm:text-3xl lg:text-4xl xl:text-5xl font-black text-black leading-snug -mt-24 sm:mt-0`}
  span {
    ${tw`inline-block mt-2`}
  }
`;

const Link = tw.a`border-b-2 border-transparent hocus:text-green-600 hocus:border-red-300 pb-1 transition duration-300 mt-2 mx-4`;


const BeginnersCourse2023 = () => {
  return (
    <Container2023>
      <HeroContainer>
        <TwoColumn>
          <LeftColumn>
          <Content>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <SubHeading>
            5 or 6 weeks<br />
            Every Thursday @ 7pm<br />
            Cost of £30<br />
            Email <Link href="mailto:aberfencing@gmail.com?subject=beginner%20course">aberfencing@gmail.com</Link><br/>
             &nbsp; if interested.<br />
            </SubHeading>
            {/* <PrimaryButton buttonRounded={false} as="a" target="_blank" href={""}>
              {"More Details Coming Soon"}
            </PrimaryButton> */}
            <br />
            <br />
            <br />
</Content>
          </LeftColumn>
        </TwoColumn>
      </HeroContainer>
    </Container2023>
  );
};
export { BeginnersCourse2023 };
export default () => {
  return (
    <Container>
      <HeroContainer>
        <TwoColumn>
          <LeftColumn>
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <br />
            <PrimaryButton buttonRounded={false} as="a" target="_blank" href={"https://drive.google.com/file/d/1Y71-oumEgNb8C3kpsRCFCqwG5m3FbTAM/view?usp=sharing"}>
              {"Read More"}
            </PrimaryButton>
            <br />
            <br />
            <br />
          </LeftColumn>
        </TwoColumn>
      </HeroContainer>
    </Container>
  );
};
